/**
 *
 * Password strength from zxcvbn scores
 */
export const PasswordScoreEnum = {
  0: 'Very Weak',
  1: 'Weak',
  2: 'Medium',
  3: 'Strong',
  4: 'Very Strong'
}

/**
 *
 * Strength color as percentages
 */
export const PasswordScoreColorEnum = {
  0: '#ee3354',
  25: '#f76885',
  50: '#fda600',
  75: '#00af52',
  100: '#008b3a'
}



// WEBPACK FOOTER //
// ./src/constants/password-score.constants.js